export const BASE_URL = process.env.REACT_APP_API_HOST;
export const API_GOOGLE_AUTH = "/auth/google";
export const API_EMAIL_SEND_CODE = "/auth/email/send-code";
export const API_EMAIL_REGISTER = "/auth/email/register";
export const API_EMAIL_RESET_PWD = "/auth/email/reset-pwd";
export const API_EMAIL_LOGIN = "/auth/email/login";
export const API_USER_INFO = "/user/info";
export const API_DESIGN_NAME = "/name/design";
export const API_UPDATE_NAME = "/name/update";
export const API_NAME_RECORDS = "/name/records";
export const API_UNLOCKED_NAMES = "/name/unlocked";
export const API_PAYMENT_CHECKOUT = "/payment/checkout";
